// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__IjdX6","label":"Completed_label__2-y3w"};